import {useSelector} from "react-redux";
import {RootState} from "../../app/store";
import {Label} from "./Label";
import {RulerComponent} from "./Ruler";
import {useEffect, useRef} from "react";
import {useControls} from "react-zoom-pan-pinch";
import {useAppDispatch} from "../../app/hooks";
import {SetZoomValue} from "../MainActions";
import localforage from "localforage";

interface Props {
  zoom: number;
  setZoom: (zoom: number) => void;
  setPanDisabled: (i: boolean) => void;
}
export const Canvas = ({zoom, setZoom, setPanDisabled}: Props) => {
  const {labelParams} = useSelector((state: RootState) => state.labelEdit.present);
  const {setTransform, instance, resetTransform} = useControls();
  const dispatch = useAppDispatch();
  
  // Use refs to avoid re-registering event listeners
  const instanceRef = useRef(instance);
  const setTransformRef = useRef(setTransform);
  const resetTransformRef = useRef(resetTransform);
  const setPanDisabledRef = useRef(setPanDisabled);
  const dispatchRef = useRef(dispatch);
  
  // Keep refs updated
  useEffect(() => {
    instanceRef.current = instance;
    setTransformRef.current = setTransform;
    resetTransformRef.current = resetTransform;
    setPanDisabledRef.current = setPanDisabled;
    dispatchRef.current = dispatch;
  });
  useEffect(() => {
    localforage.getItem("zoom").then((value) => {
      if (value) {
        setTransform(0, 0, parseFloat(value.toString()), 0);
      } else if (labelParams.zoom !== 1) {
        setTransform(0, 0, labelParams.zoom, 0);
      }
    });
  }, []);
  useEffect(() => {
    // console.log('[Canvas] Registering keyboard/wheel handlers');
    const handleKeyDown = (event: any) => {
      if ((event.ctrlKey || event.metaKey) && (event.key === "=" || event.key === "+" || event.key === "-")) {
        event.preventDefault();
        if (event.key === "=" || event.key === "+") {
          const newScale = instanceRef.current.transformState.scale + 0.25;
          dispatchRef.current(SetZoomValue(newScale));
          setTransformRef.current(0, 0, newScale, 0);
        } else {
          const newScale = instanceRef.current.transformState.scale - 0.25;
          dispatchRef.current(SetZoomValue(newScale));
          setTransformRef.current(0, 0, newScale, 0);
        }
      } else if ((event.ctrlKey || event.metaKey) && event.key === "0") {
        event.preventDefault();
        resetTransformRef.current();
        dispatchRef.current(SetZoomValue(1));
      } else {
        return;
      }
    };

    const handleKeyUp = (event: any) => {
      if (event.ctrlKey || event.metaKey || event.key === "Control" || event.key === "Meta") {
        setPanDisabledRef.current(true);
      }
    };

    const handleWheel = (e: any) => {
      if (e.ctrlKey || e.metaKey) {
        e.preventDefault();
        setPanDisabledRef.current(false);
      } else {
        setPanDisabledRef.current(true);
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("keyup", handleKeyUp);
    document.addEventListener("wheel", handleWheel, {passive: false});

    return () => {
      // console.log('[Canvas] Cleanup keyboard/wheel handlers');
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("keyup", handleKeyUp);
      document.removeEventListener("wheel", handleWheel);
    };
  }, []);
  return (
    <div style={{width: 1000000}}>
      <div style={{height: labelParams.heightInPx + 10000, width: labelParams.widthInPx + 10000}}>
        <RulerComponent
          type="horizontal"
          style={{
            position: "absolute",
            top: 0,
            left: 30,
            width: labelParams.widthInPx,
            height: "30px",
          }}
        />
        <RulerComponent
          type="vertical"
          style={{
            position: "absolute",
            top: 30,
            left: 0,
            width: "30px",
            height: labelParams.heightInPx,
          }}
        />
        <Label zoom={zoom} setZoom={setZoom} />
      </div>
    </div>
  );
};
